<template>
  <div class="breadcrumb">
    <div class="l-container l-container-padding">
      <div class="breadcrumb-inner">
        <breadcrumb-list v-bind:breadcrumbs="breadcrumbs"></breadcrumb-list>

        <breadcrumb-menu></breadcrumb-menu>>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbList from "@/components/molecules/BreadcrumbList";
import BreadcrumbMenu from "@/components/molecules/BreadcrumbMenu";

export default {
  props: ["breadcrumbs"],
  components: {
    BreadcrumbList,
    BreadcrumbMenu,
  },
};
</script>
